enum PreviewType {
  REAL_DATA,
  SAMPLE_DATA,
}

export default PreviewType;
